import swaggerJsDoc from 'swagger-jsdoc';
import swaggerUi from 'swagger-ui-express';
import "reflect-metadata";
import { PlataformConfig } from './infrastructure/config/plataform.js';
import { classToJsonSchema } from "@nantoidigital/nantoi-lib-infrastructure-core/dist/types/infrastructure/template/SchemaTemplate.js"
import { folderPath, listJsFiles, loadSchemasFromFiles } from './infrastructure/config/modules.js';

const { activeModules } = PlataformConfig;


// Converte os caminhos relativos dos módulos em caminhos absolutos para as rotas
const pathToRoutes = activeModules.flatMap(module =>
  module.swagger.routesFolders.map(folder =>
    folderPath(module.name, module.outDir, folder)
  )
);


// Converte os caminhos relativos dos módulos em caminhos absolutos para os domínios
const pathToDomains = activeModules.flatMap(module =>
  module.swagger.domainFolders.flatMap(folder => listJsFiles(module.name, module.outDir, folder))
);



// Carrega os schemas dos arquivos especificados em `domainFolders`
const domainSchemas = await loadSchemasFromFiles(pathToDomains);

// Convert class schemas to JSON schemas
const jsonSchemas = Object.keys(domainSchemas).reduce((acc, key) => {
  const schema = domainSchemas[key];
  // Ensure schema is a class constructor
  if (typeof schema === 'function') {
    acc[key] = classToJsonSchema(schema);
  }
  return acc;
}, {});


const options = {
  swaggerDefinition: {
    openapi: '3.0.0',
    info: {
      title: 'Nantoi API CORE',
      version: '31.8.1',
    },
    servers: [
      {
        url: `http://localhost:3000${PlataformConfig.url.baseUrl}/`
      },
    ],
    components: {
      securitySchemes: {
        BearerAuth: {
          type: 'http',
          scheme: 'bearer',
          bearerFormat: 'JWT',
        },
      },
      schemas: {
        ...jsonSchemas, // Incorpora os schemas carregados a partir de domainFolders
      },
    },
    security: [
      {
        BearerAuth: [],
      },
    ],
  },
  apis: [
    ...pathToRoutes,
  ],
};

const specs = swaggerJsDoc(options);

export default (app) => {
  app.use(PlataformConfig.url.api, swaggerUi.serve, swaggerUi.setup(specs));
};
